import React from "react";
import { MainBlockBannerModel } from "@admin/domain/uniquePages/models/MainPageModel";
import ImageInput from "@admin/components/ImageInput";
import { FileModel } from "@admin/domain/files/model/FileModel";

type Props = {
    banner: MainBlockBannerModel;
    index: number;
    editBanner: (banner: MainBlockBannerModel) => void;
};

export default function BannerImages({ banner, index, editBanner }: Props) {
    return (
        <>
            <ImageInput
                label="Изображение"
                name={`content[main_block__banners][${index}][file_id]`}
                onChange={(file: FileModel | null): void => editBanner({ ...banner, file })}
                defaultValue={banner.file}
                className={{ container: `p-5 pb-0`, image: `img-thumbnail` }}
            />

            {banner.with_mobile_app_file && (
                <ImageInput
                    label="Изображение для МП"
                    name={`content[main_block__banners][${index}][mobile_app_file_id]`}
                    onChange={(file: FileModel | null): void => editBanner({ ...banner, mobile_app_file: file })}
                    defaultValue={banner.mobile_app_file}
                    className={{ container: `p-5 pb-0`, image: `img-thumbnail` }}
                />
            )}

            <input
                name={`content[main_block__banners][${index}][with_mobile_app_file]`}
                value={banner.with_mobile_app_file ? `1` : `0`}
                type="hidden"
            />
        </>
    );
}
